module.exports = __webpack_public_path__ + "img/logo1.21da61d4.png";